import React, { useEffect } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { formatDate, toDisplayDecimal } from '../../utils';
import bag_coin from "../../images/money.png";

const useStyles = makeStyles((theme) => ({
    divContent: {
        margin: '5px 15px',
        padding: '4px 10px',
        textAlign: 'left',
        color: 'var(--color2)',
        display: 'inline-block',
        float: 'left',
        '& > div > svg': {
            float: 'left',
            margin: '4px 10px !important',
            width: '18px'
        },
        '& > span': {
            display: 'table'
        }
    },
    title: {
        fontWeight: 'bold'
    },
    divAmound: {
        display: 'table',
        borderRadius: '8px',
        width: '204px',
        textAlign: 'center'
    },
    amount: {
        color: 'var(--color2)',
        fontSize: '40px',
        whiteSpace: 'nowrap',
        fontWeight: 'bold'
    },
    blur: {
        filter: 'blur(10px)'
    },
    divRootPayroll: {
        color: '#ffffff',
        display: 'inline-block',
        float: 'left',
        paddingBottom: '10px',
        width: '100%',
        textAlign: 'left',
        '& > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
    },
    payrollImg: {
        width: '40px',
    },
    payrollTitle: {
        verticalAlign: 'middle',
        marginLeft: '5px',
        fontVariant: 'all-petite-caps',
        fontSize: '18px'
    }
}));

function Payroll(props) {
    const classes = useStyles();

    const [data, setData] = React.useState('');
    const [isBlur, setIsBlur] = React.useState(true);

    useEffect(() => {
        if (props.data !== null) {
            loadPayroll();
        }
    }, [props.data]);

    const loadPayroll = () => {
        setData(props.data);
    }

    const handleBlur = () => {
        setIsBlur(!isBlur);
    }

    return (
        <>
            <div className={classes.divRootPayroll}>
                <img className={classes.payrollImg} src={bag_coin} />
                <span className={classes.payrollTitle}>{i18next.t('home:homeContent.payroll')}</span>
            </div>
            <div className={classes.divContent}>
                <div>
                    <span className={classes.title}>{i18next.t('payroll:titleDate')}{i18next.t('common:labelSeparator')} </span>
                    <span>{formatDate(data?.date, 'date')}</span>
                </div>
                <div onClick={handleBlur} className={`${isBlur ? classes.blur : ''}`}>
                    <div>
                        <span className={classes.title}>{i18next.t('payroll:titleGrossAmount')}{i18next.t('common:labelSeparator')} </span>
                        <span>{toDisplayDecimal(data?.grossPay, 2, true)}</span>
                    </div>
                    <div>
                        <span className={classes.title}>{i18next.t('payroll:titleNetPayment')}{i18next.t('common:labelSeparator')} </span>
                        <div className={classes.divAmound}>
                            <span className={`${classes.amount}`}>{toDisplayDecimal(data?.netPay, 2, true)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default withNamespaces(['home', 'common', 'payroll'], { wait: true })(Payroll);